// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nfty-border[data-v-9d931456]{border:2px solid #e4e4e4!important;background-color:#fff!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
